"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import type { BaseProviderFormProps } from "@/components/settings/data-providers/provider-forms/base-provider-form";
import { InstructionsWrapper } from "@/components/settings/data-providers/provider-forms/instructions-wrapper";
import { FormInput } from "@/components/ui/input";
import { ProviderType } from "@/types/dataProvider";
export const ShowMojoProviderForm = t0 => {
  const $ = _c(9);
  const {
    form,
    isCreating,
    isEditMode: t1
  } = t0;
  const isEditMode = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ol><li>Sign in to your ShowMojo account.</li><li>Open account settings and navigate to API access.</li><li>Generate or copy your existing API token and paste it below.</li></ol>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isEditMode) {
    t3 = <InstructionsWrapper accordion={isEditMode} title="How to find your API token:">{t2}</InstructionsWrapper>;
    $[1] = isEditMode;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== form || $[4] !== isCreating) {
    t4 = <FormInput autoComplete="off" disabled={isCreating} form={form} label="API Token" name="data.credentials.apiToken" placeholder="Enter ShowMojo API token" type="password" />;
    $[3] = form;
    $[4] = isCreating;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
(ShowMojoProviderForm as any).providerType = ProviderType.SHOWMOJO;